import { useState, useEffect } from 'react'
import { Modal, Form, Button, Row, Col, Alert, Spinner } from 'react-bootstrap'

function CreatorForm({ show, onHide, onSubmit, creator, loading }) {
  const [formData, setFormData] = useState({
    user_email: '',
    code: '',
    tier: 'F1',
    commission_rate: 10,
    description: '',
  })
  const [error, setError] = useState('')

  useEffect(() => {
    if (creator) {
      setFormData({
        user_email: creator.user_email || creator.email || '',
        code: creator.code || '',
        tier: creator.tier || 'F1',
        commission_rate: creator.commission_rate || 10,
        description: creator.description || '',
      })
    } else {
      setFormData({
        user_email: '',
        code: '',
        tier: 'F1',
        commission_rate: 10,
        description: '',
      })
    }
    setError('')
  }, [creator, show])

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }))
  }

  const handleTierChange = (tier) => {
    const tierRates = {
      'F1': 10,
      'F2': 15,
      'F3': 20,
      'F4': 25,
    }
    setFormData(prev => ({
      ...prev,
      tier,
      commission_rate: tierRates[tier] || 10,
    }))
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    setError('')

    if (!creator && !formData.user_email.trim()) {
      setError('L\'email de l\'utilisateur est obligatoire')
      return
    }

    if (!formData.code.trim()) {
      setError('Le code créateur est obligatoire')
      return
    }

    onSubmit({
      ...formData,
      commission_rate: Number(formData.commission_rate),
    })
  }

  const tierOptions = [
    { value: 'F1', label: 'F1 - Bronze (10%)', description: '10% de commission sur les ventes' },
    { value: 'F2', label: 'F2 - Argent (15%)', description: '15% de commission sur les ventes' },
    { value: 'F3', label: 'F3 - Or (20%)', description: '20% de commission sur les ventes' },
    { value: 'F4', label: 'F4 - Platine (25%)', description: '25% de commission sur les ventes' },
  ]

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>{creator ? 'Modifier le créateur' : 'Ajouter un créateur'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {error && <Alert variant="danger">{error}</Alert>}

          {!creator && (
            <Form.Group className="mb-3">
              <Form.Label>Email de l'utilisateur *</Form.Label>
              <Form.Control
                type="email"
                name="user_email"
                value={formData.user_email}
                onChange={handleChange}
                placeholder="utilisateur@exemple.com"
              />
              <Form.Text className="text-muted">
                L'utilisateur doit déjà avoir un compte sur la plateforme
              </Form.Text>
            </Form.Group>
          )}

          <Row className="mb-3">
            <Col md={6}>
              <Form.Group>
                <Form.Label>Code créateur *</Form.Label>
                <Form.Control
                  type="text"
                  name="code"
                  value={formData.code}
                  onChange={handleChange}
                  placeholder="CREATEUR2026"
                  disabled={!!creator}
                />
                <Form.Text className="text-muted">
                  Le code que les utilisateurs utiliseront lors de l'inscription
                </Form.Text>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Description</Form.Label>
                <Form.Control
                  type="text"
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  placeholder="Nom du créateur ou description"
                />
              </Form.Group>
            </Col>
          </Row>

          <Form.Group className="mb-3">
            <Form.Label>Tier de commission</Form.Label>
            <div className="d-flex flex-wrap gap-3">
              {tierOptions.map(option => (
                <Form.Check
                  key={option.value}
                  type="radio"
                  id={`tier-${option.value}`}
                  name="tier"
                  label={
                    <span>
                      <strong>{option.label}</strong>
                      <br />
                      <small className="text-muted">{option.description}</small>
                    </span>
                  }
                  checked={formData.tier === option.value}
                  onChange={() => handleTierChange(option.value)}
                />
              ))}
            </div>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Taux de commission personnalisé (%)</Form.Label>
            <Form.Control
              type="number"
              name="commission_rate"
              value={formData.commission_rate}
              onChange={handleChange}
              min="1"
              max="50"
              style={{ maxWidth: '150px' }}
            />
            <Form.Text className="text-muted">
              Généralement défini par le tier, mais peut être ajusté manuellement
            </Form.Text>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide} disabled={loading}>
            Annuler
          </Button>
          <Button variant="primary" type="submit" disabled={loading}>
            {loading ? (
              <>
                <Spinner animation="border" size="sm" className="me-2" />
                Enregistrement...
              </>
            ) : creator ? 'Mettre à jour' : 'Ajouter'}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  )
}

export default CreatorForm
